import Link from "next/link"

import data from "./data"

const Tag = ({ tag }) => {
  return (
    <Link
      href={`topics/${tag}`}
      className="m-1 rounded-full  bg-gray-200 px-1 py-1 text-sm dark:bg-gray-900"
    >
      {tag}
    </Link>
  )
}
const CourseCard = ({ course }) => {
  const {
    id,
    name,
    price,
    hours,
    link,
    tags,
    startDate,
    endDate,
    days,
    intensity,
    type,
    description,
    descriptionExtra,
    active,
    groupSize,
    isPopular,
  } = course
  const tagList = (
    <p>
      Tags:
      {tags.map((tag) => (
        <Tag tag={tag} key={tag}></Tag>
      ))}
    </p>
  )
  return (
    <div className="my-background relative flex max-w-none flex-col overflow-hidden">
      {isPopular && (
        <div className="absolute right-0 top-0 h-16 w-16">
          <div className="absolute left-[-65px] top-[28px] w-[180px] rotate-45 transform bg-darkLevander py-1 text-center font-semibold text-white shadow-lg">
            Populiarus
          </div>
        </div>
      )}

      <h2 id={id}>{name}</h2>
      <p>{description}</p>
      {descriptionExtra && <div className="py-2">{descriptionExtra}</div>}

      <div className="flex items-center justify-between">
        <p>Trukmė: {hours} valandų</p>
        {active ? (
          <Link
            className={`transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold uppercase transition-colors duration-1000 dark:bg-green-500 dark:text-black`}
            // bg-gradient-to-br from-white via-white to-gray-50
            href={`courses/${link}`}
          >
            Detaliau
          </Link>
        ) : (
          <a
            className={`transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black`}
            // bg-gradient-to-br from-white via-white to-gray-50
            href={data.links.generalRegistrationForm}
            rel="noopener noreferrer"
            target="_blank"
          >
            Teirautis
          </a>
        )}
      </div>

      {/* <div>{hours / price}</div> */}
    </div>
  )
}

export default CourseCard
